import { Spacing, SpacingName, Typography } from '@doveit/lego';
import React from 'react';
import ArticleMarkdown from '../../article-markdown/ArticleMarkdown';
import Markdown from '../../markdown/Markdown';
import * as styles from './ArticleFAQ.style';
import { FAQ } from '../../../types';

export interface ArticleFAQProps {
  title: string,
  items: FAQ[],
}

export const ArticleFAQ: React.FC<ArticleFAQProps> = ({
  title,
  items = [],
}) => (
  <div>
    <Typography.H3 tagName="div">
      <Markdown>
        {title.trim()}
      </Markdown>
    </Typography.H3>
    <Spacing margin={[SpacingName.MEDIUM, 0, 0]}>
      {items.map((faq) => (
        <div
          key={faq.id}
          css={styles.item}
        >
          <Typography.H4 tagName="h2">
            {faq.question.trim()}
          </Typography.H4>
          <Spacing margin={[SpacingName.SMALL, 0, 0]}>
            <ArticleMarkdown>
              {faq.answer.trim()}
            </ArticleMarkdown>
          </Spacing>
        </div>
      ))}
    </Spacing>
  </div>
);

export default ArticleFAQ;
